import React from 'react';
import { Modal } from 'react-bootstrap';
import { QRCodeSVG } from 'qrcode.react';
import { Capacitor } from '@capacitor/core';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { KTSVG } from '../../../../_metronic/helpers/components/KTSVG';
import { useAuth } from '../../auth';
import './PostureScanInfoModal.css';

type Props = {
  show: boolean;
  handleClose: () => void;
};

const isMobileDevice = (): boolean => {
  // Check if running on native platform (Capacitor)
  if (Capacitor.isNativePlatform()) {
    return true;
  }
  // Check for mobile user agent in browser
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
};

const openScanLink = (url: string) => {
  window.open(url, '_blank');
};

const PostureScanInfoModal: React.FC<Props> = ({ show, handleClose }) => {
  const { currentUser } = useAuth();
  const crmClientId = currentUser?.CRMClientId || '';
  const postureScanUrl = `https://plus.futurisk.in/posture-scan?crmclientid=${encodeURIComponent(crmClientId)}`;
  const isMobile = isMobileDevice();

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      centered
      dialogClassName="posturescan-info-modal"
    >
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className="w-100">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="fw-bold text-dark mb-0">Posture Scan</h2>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              onClick={handleClose}
            >
              <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3">
        <div className="row">
          {/* Left side - Info Image */}
          <div className="col-md-7 col-12 mb-4 mb-md-0">
            <div className="info-image-container">
              <img
                src={toAbsoluteUrl('/media/partner/postureinfo.png')}
                alt="Posture Scan Information"
                className="img-fluid rounded info-image"
              />
            </div>
            
          </div>

          {/* Right side - QR Code or Open Button */}
          <div className="col-md-5 col-12">
            <div className="qr-code-container text-center p-4 bg-light rounded">
              {isMobile ? (
                <>
                  <h5 className="fw-bold text-dark mb-3">Ready to Scan</h5>
                  <div className="my-4">
                    <button
                      className="btn btn-warning btn-lg px-5 py-3"
                      onClick={() => {
                        openScanLink(postureScanUrl);
                        handleClose();
                      }}
                    >
                      <i className="bi bi-person-standing me-2"></i>
                      Open Posture Scan
                    </button>
                  </div>
                  <p className="text-muted mt-3 mb-0 small">
                    Tap the button above to start your Posture Scan assessment
                  </p>
                </>
              ) : (
                <>
                  <h5 className="fw-bold text-dark mb-3">Scan to Start</h5>
                  <div className="qr-code-placeholder">
                    <div className="qr-code-box">
                      <QRCodeSVG
                        value={postureScanUrl}
                        size={180}
                        bgColor="#ffffff"
                        fgColor="#333333"
                        level="M"
                        includeMargin={false}
                      />
                    </div>
                  </div>
                  <p className="text-muted mt-3 mb-0 small">
                    Scan the QR code with your mobile device to begin your Posture Scan assessment
                  </p>
                </>
              )}
            </div>
            <div className="mt-4 p-3 bg-warning bg-opacity-10 rounded">
              <h6 className="fw-bold text-warning mb-2">
                <i className="bi bi-info-circle me-2"></i>
                Important Note
              </h6>
              <p className="text-muted mb-0 small">
                Stand in a well-lit area and ensure your full body is visible within the camera frame for accurate posture analysis.
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export { PostureScanInfoModal };
